import {formatDate as formatGridDate} from '~/components/data-grid/cells/gridCellFormat';
import {LOCALE} from './locale';

/** A date on the Category Profile pages: "30 Jun 2027" in the deployment's locale, the calendar day as stored. */
export function formatDate(value: string | null): string {
    return formatGridDate(value, LOCALE);
}
